import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { DimensionInput } from 'ui-components/components/dimension-input';

import { convertDimensions } from '../../services/unit-services/dimensions/dimension-convert-service';
import {
  convertFromDimensionUnitEnum,
  convertToDimensionUnitEnum,
} from '../../services/unit-services/dimensions/dimension-unit-enum-converter';
import Global from '../../store/global-selectors';

import type { UnitPosition } from '../../enums/units/unit-display-types';
import type { Dimensions } from '../../prop-types/dimension-types';

type ConvertedDimensionsInputProps = {
  dimensions: Dimensions;
  onChange: (dimensions: Dimensions) => void;
  inputClassName?: string | null;
  unitPosition?: UnitPosition;
  numberInputsContainerClassName?: string;
  className?: string | null;
};

export const ConvertedDimensionsInput: React.FC<ConvertedDimensionsInputProps> = React.memo(
  ({ dimensions, onChange, inputClassName, unitPosition, numberInputsContainerClassName, className }) => {
    const sellerUnit = useSelector(Global.selectSellerDefaultDimensionUnit);
    const convertedDimensions = convertDimensions(dimensions, sellerUnit);
    const unit = convertFromDimensionUnitEnum(sellerUnit);

    const onChangeCallback = useCallback(
      (inputDimensions: Dimensions) => {
        const convertedUnit = convertToDimensionUnitEnum(inputDimensions.unit);
        const newDimensions = {
          ...inputDimensions,
          unit: convertedUnit,
        };

        onChange(newDimensions);
      },
      [onChange],
    );

    return (
      <DimensionInput
        className={className}
        dimensions={convertedDimensions}
        inputClassName={inputClassName}
        numberInputsContainerClassName={numberInputsContainerClassName}
        onChange={onChangeCallback}
        unit={unit}
        unitPosition={unitPosition}
      />
    );
  },
);

ConvertedDimensionsInput.displayName = 'ConvertedDimensionsInput';
